import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  formControl: {
    width: 672,
    marginBottom: 41,
  },
  formControlMobile: {
    width: '100%',
    marginBottom: 41,
    marginTop: 32,
  }
}))

export default useStyles
